import { redirectRoute } from '../helpers';
import { DisruptionAlertsPages } from '../../constants/AppConstants';

export default {
    path: '/disruption-alerts',

    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/disruptionAlert/landing/Handler').default);
        }, 'disruption-alerts-handler');
    },

    indexRoute: redirectRoute(null, DisruptionAlertsPages.MUTE),

    getChildRoutes(location, cb) {
        require.ensure([], (require) => {
            cb(null, [
                require('./Mute').default,
            ].filter(Boolean));
        }, 'disruption-alerts-routes');
    },
};
